import React from "react";
import { Row, Col } from "reactstrap";
import SlideShow from "./SlideShow";
import SlideInfo from "./SlideInfo";

const Header = () => {
  return (
    <Row className="row-eq-height mx-0 section__ppal d-flex flex-column align-items-center" noGutters>
      <Col xs="12" sm='12' style={{}}>
      <div style={{ maxHeight: "1000px", overflow: "hidden", width: "100%" }}>
          <SlideShow />
        </div>      
        <SlideInfo />
      </Col>

    </Row>
  );
};

export default Header;
